import { render, staticRenderFns } from "./TwoFaCode.vue?vue&type=template&id=7dff6f11&scoped=true&"
import script from "./TwoFaCode.vue?vue&type=script&lang=js&"
export * from "./TwoFaCode.vue?vue&type=script&lang=js&"
import style0 from "./TwoFaCode.vue?vue&type=style&index=0&id=7dff6f11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dff6f11",
  null
  
)

export default component.exports